/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.messages\":\"Kaksi puhekuplaa\"}");